import { render, staticRenderFns } from "./ProfileAside.vue?vue&type=template&id=445209fe&scoped=true&"
import script from "./ProfileAside.vue?vue&type=script&lang=js&"
export * from "./ProfileAside.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAside.vue?vue&type=style&index=0&id=445209fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445209fe",
  null
  
)

export default component.exports